import type { GroupedTask, MinifiedTask } from '@gcv/shared';
import { TaskInternalExternal, TaskStatus } from '@gcv/shared';
import { useQuery } from '@tanstack/react-query';

import { TasksApi } from 'api/TasksApi';
import { BANK_TASKS_KEY } from 'hooks/keys';
import { useUser } from './useUser';

export function useBankTasks(startDate: string, endDate: string) {
  const { userBankId } = useUser();
  const tasksApi = new TasksApi();

  const { data: bankTasks, isLoading: isLoadingBankTasks } = useQuery<(MinifiedTask | GroupedTask)[]>({
    enabled: !!userBankId,
    queryKey: [BANK_TASKS_KEY, userBankId, startDate, endDate],
    queryFn: async () => {
      const response = await tasksApi.getBankTasksV2(
        userBankId,
        userBankId,
        TaskInternalExternal.EXTERNAL,
        startDate,
        endDate,
        [TaskStatus.OPEN, TaskStatus.COMPLETE]
      );
      return response.tasks;
    },
    meta: {
      snackbarErrorMessage:
        'There was an issue loading tasks. Please contact support if the problem persists.'
    }
  });

  return { bankTasks, isLoadingBankTasks };
}
